import _ from '../../core/utils'
import RESOURCES_CONFIG from './config'
import API from '../api'
import Isotope from 'isotope-layout'
import imagesLoaded from 'imagesloaded'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin'
gsap.registerPlugin( ScrollToPlugin )

class ResourcesClass {
    constructor() {
        this.DOM = {
            section: RESOURCES_CONFIG.section,
            search: {
                form: RESOURCES_CONFIG.search.form,
                input: RESOURCES_CONFIG.search.input,
                clear: RESOURCES_CONFIG.search.clear,
                loader: RESOURCES_CONFIG.search.loader,
                submit: RESOURCES_CONFIG.search.submit,
            },
            filter: RESOURCES_CONFIG.filter,
            grids: {
                publications: {
                    wrap: null,
                    items: null,
                    noresults: null,
                    show: null,
                    isotope: null
                },
                presentations: {
                    wrap: null,
                    items: null,
                    noresults: null,
                    show: null,
                    isotope: null
                },
                videos: {
                    wrap: null,
                    items: null,
                    noresults: null,
                    show: null,
                    isotope: null
                },
                webinars: {
                    wrap: null,
                    items: null,
                    noresults: null,
                    show: null,
                    isotope: null
                },
                courses: {
                    wrap: null,
                    items: null,
                    noresults: null,
                    show: null,
                    isotope: null
                }
            }
        }

        this.load = null
        this.searched = false
        this.filtered = false
        this.endpoint = RESOURCES_CONFIG.endpoint
        this.isotopes = []
        this.shows = []
        this.grids = []
        this.DOM.section ? this.init() : null
    }

    init() {
        this._setLoad()
        this._setGrids()
        this._isotopes()
        this._listeners()
        console.log( this )
    }

    _setLoad() {
        this.load = parseInt( this.DOM.section.getAttribute( 'data-load' ) )
    }

    _setGrids() {
        this.DOM.grids.publications.wrap = _.select( '.section--resources-content .resources__block--publications' )
        this.DOM.grids.publications.items = _.selectAll( '.section--resources-content .resources__block--publications .fl__card--resource' )
        this.DOM.grids.publications.noresults = _.select( '.section--resources-content .resources__block--publications .fl__card--noresults' )
        this.DOM.grids.publications.show = _.select( '.section--resources-content .resources__block--publications .resources__all' )

        this.DOM.grids.presentations.wrap = _.select( '.section--resources-content .resources__block--presentations' )
        this.DOM.grids.presentations.items = _.selectAll( '.section--resources-content .resources__block--presentations .fl__card--resource' )
        this.DOM.grids.presentations.noresults = _.select( '.section--resources-content .resources__block--presentations .fl__card--noresults' )
        this.DOM.grids.presentations.show = _.select( '.section--resources-content .resources__block--presentations .resources__all' )

        this.DOM.grids.videos.wrap = _.select( '.section--resources-content .resources__block--videos' )
        this.DOM.grids.videos.items = _.selectAll( '.section--resources-content .resources__block--videos .fl__card--resource' )
        this.DOM.grids.videos.noresults = _.select( '.section--resources-content .resources__block--videos .fl__card--noresults' )
        this.DOM.grids.videos.show = _.select( '.section--resources-content .resources__block--videos .resources__all' )

        this.DOM.grids.webinars.wrap = _.select( '.section--resources-content .resources__block--webinars' )
        this.DOM.grids.webinars.items = _.selectAll( '.section--resources-content .resources__block--webinars .fl__card--resource' )
        this.DOM.grids.webinars.noresults = _.select( '.section--resources-content .resources__block--webinars .fl__card--noresults' )
        this.DOM.grids.webinars.show = _.select( '.section--resources-content .resources__block--webinars .resources__all' )

        this.DOM.grids.courses.wrap = _.select( '.section--resources-content .resources__block--courses' )
        this.DOM.grids.courses.items = _.selectAll( '.section--resources-content .resources__block--courses .fl__card--resource' )
        this.DOM.grids.courses.noresults = _.select( '.section--resources-content .resources__block--courses .fl__card--noresults' )
        this.DOM.grids.courses.show = _.select( '.section--resources-content .resources__block--courses .resources__all' )
    }

    _listeners() {

       
        this.DOM.search.form.addEventListener( 'submit', this._search.bind( this ) )
        this.DOM.search.clear.addEventListener( 'click', this._clear.bind( this ) )
        this.DOM.filter.addEventListener( 'change', this._filter.bind( this ) )
    }

    _isotopes() {

        Object.keys( this.DOM.grids ).map( ( type ) => {
            // Create isotopes
            if ( this.DOM.grids[type].wrap ) {
                this.DOM.grids[type].isotope = new Isotope( _.select( '.fl__card-grid', this.DOM.grids[type].wrap ) )
                this.isotopes.push( this.DOM.grids[type].isotope )
                this.grids.push( this.DOM.grids[type] )
            }
            // Add show more event
            if ( this.DOM.grids[type].show ) {
                this.shows.push( this.DOM.grids[type].show )
                this.DOM.grids[type].show.addEventListener( 'click', this._showAll.bind( this ) )
            }
            // Hide overload items
            if ( this.DOM.grids[type].wrap ) {
                this.DOM.grids[type].items.forEach( ( item, key ) => {
                   if ( key > this.load - 1 ) {
                       _.addClass( item, 'fl__card--hide' )
                   }
                })
            }
        })

        imagesLoaded( this.DOM.section ).on( 'progress', () => {
            this.isotopes.forEach( ( isotope ) => {
                isotope.arrange({
                    filter: '.fl__card--resource:not(.fl__card--hide)'
                })
            })
        })

    }

    _filter() {
        let value = event.target.value

        this._filterCards( value )
        this._allowed()
    }

   
    _filterCards( value ) {
        this.grids.forEach( ( grid ) => {
            if ( value != 'all' ) {
                this.filtered = true
                grid.items.forEach( ( item ) => {
                    if ( item.getAttribute( 'data-type' ) == value ) {
                        _.addClass( item, 'fl__card--filtered' )
                    } else {
                        _.removeClass( item, 'fl__card--filtered')
                    }
                })
                let filteredLength = _.selectAll( '.fl__card--filtered', grid.wrap ).length

                if ( filteredLength > 0 ) {
                    grid.wrap.style.display = 'block'
                    grid.isotope.arrange({
                        filter: '.fl__card--filtered'
                    })
                } else {
                    grid.wrap.style.display = 'none'
                }
               
                if ( grid.show ) {
                    grid.show.style.opacity = 0
                    grid.show.style.pointerEvents = 'none'
                }
                
                
            } else {
                this.filtered = false
                if ( grid.show ) {
                    grid.show.style.opacity = 1
                    grid.show.style.pointerEvents = 'all'
                }
                grid.wrap.style.display = 'block'
                grid.items.forEach( ( item ) => {
                    _.removeClass( item, 'fl__card--filtered')
                })
                grid.isotope.arrange({
                    filter: '.fl__card--resource:not(.fl__card--hide)'
                })
            }
        })

    }

    _search() {
        event.preventDefault()

        _.addClass( this.DOM.section, 'is--searching' )

        API.post( this.endpoint, 
            new FormData( this.DOM.search.form )
        )
        .then( ( response ) => {
            console.log( response )
            if ( response.data.success ) {
                this._results( response )
            }
        })
        .catch( ( error ) => {
            console.log( error )
        })
        .then( () => {
            _.removeClass( this.DOM.section, 'is--searching' )
            _.addClass( this.DOM.section, 'is--searched' )
        })

        this.searched = true
    }

    _results( response ) {
        
        this._resultsCards( response )
        this._allowed()
        
    }

    _resultsCards( response ) {
        
        this.grids.forEach( ( grid ) => {
            grid.items.forEach( ( item ) => {
                _.removeClass( item, 'fl__card--filtered' )
            })
        })

        if ( response.data.results.length > 0 ) {

            _.removeClass( this.DOM.section, 'is--noresults' )
           let results = response.data.results

            this.grids.forEach( ( grid ) => { 
                grid.items.forEach( ( item ) => {
                    results.forEach( ( result ) => {
                        if ( item.getAttribute( 'data-id' ) == result ) {
                            _.addClass( item, 'fl__card--filtered' )
                        }
                    })
                })
                let filteredLength = _.selectAll( '.fl__card--filtered', grid.wrap ).length

                if ( filteredLength > 0 ) {
                    grid.wrap.style.display = 'block'
                    grid.isotope.arrange({
                        filter: '.fl__card--filtered'
                    })
                } else {
                    grid.wrap.style.display = 'none'
                }
                
                if ( grid.show ) {
                    grid.show.style.opacity = 0
                    grid.show.style.pointerEvents = 'none'
                }
            })

        } else {
            _.addClass( this.DOM.section, 'is--noresults' )
        }
    }

    _clear() {
        

        _.removeClass( this.DOM.section, 'is--noresults' )
        _.removeClass( this.DOM.section, 'is--searched' )
        this.DOM.search.input.value = ''
        this.grids.forEach( ( grid ) => {
            grid.wrap.style.display = 'block'
            grid.items.forEach( ( item ) => {
                _.removeClass( item, 'fl__card--filtered' )
            })
            
            grid.isotope.arrange({
                filter: '.fl__card--resource:not(.fl__card--hide)'
            })
            
            if ( grid.show ) {
                grid.show.style.opacity = 1
                grid.show.style.pointerEvents = 'all'
            }
            
        })

        this.searched = false
        this._allowed()
    }

    _allowed() {
        if ( this.searched === true ) {
            _.addClass( this.DOM.section, 'filter--disabled' )
            _.removeClass( this.DOM.section, 'search--disabled' )
        } else if ( this.filtered === true ) {
            _.addClass( this.DOM.section, 'search--disabled' )
            _.removeClass( this.DOM.section, 'filter--disabled' )
        } else {
            _.removeClass( this.DOM.section, 'search--disabled' )
            _.removeClass( this.DOM.section, 'filter--disabled' )
        }
    }

    _showAll() {
        let type = event.currentTarget.getAttribute( 'data-iso' )
        this.DOM.grids[type].items.forEach( ( item ) => {
            _.removeClass( item, 'fl__card--hide' )
        })
        this.DOM.grids[type].isotope.arrange({
            filter: '.fl__card--resource:not(.fl__card--hide)'
        })
        event.currentTarget.style.display = 'none'
        gsap.to( document.documentElement, {
            duration: 1, 
            scrollTo: { y: this.DOM.grids[type].items[3] }
        })

    }
   
}

const RESOURCES = new ResourcesClass()
export default RESOURCES